import { c as _c } from "react/compiler-runtime";
import { Ace } from 'ace-builds';
import React, { useEffect, useState, type JSX } from 'react';
import AceEditor from 'shared/components/code-editor/components/ace-editor';
import { ignoredAnnotations } from 'shared/components/code-editor/constants/ignored-annotations';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface CodeEditorProps {
  value?: string | null;
  label?: string | JSX.Element;
  statusIcon?: React.ReactNode;
  isSuccess?: boolean;
  error?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  setIsValid?: (value: boolean) => void;
}
const CodeEditor = t0 => {
  const $ = _c(40);
  const {
    value,
    label,
    statusIcon,
    isSuccess,
    error,
    disabled,
    onChange,
    onBlur,
    setIsValid
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [annotations, setAnnotations] = useState(t1);
  const isValid = value === "" || annotations.length === 0;
  let t2;
  let t3;
  if ($[1] !== isValid || $[2] !== setIsValid) {
    t2 = () => {
      if (setIsValid) {
        setIsValid(isValid);
      }
    };
    t3 = [isValid, setIsValid];
    $[1] = isValid;
    $[2] = setIsValid;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const t4 = label && label;
  const t5 = isValid ? "border-transparent" : "border-danger";
  const t6 = error && "border-danger";
  const t7 = isSuccess && "border-green";
  let t8;
  if ($[5] !== t5 || $[6] !== t6 || $[7] !== t7) {
    t8 = twMerge("main-transition-colors relative border", t5, t6, t7);
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== statusIcon) {
    t9 = statusIcon && <div className="bg-background-secondary absolute right-2 top-2 z-20 rounded-lg p-2 shadow-lg">{statusIcon}</div>;
    $[9] = statusIcon;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: true,
      showPrintMargin: false,
      showGutter: true
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = annotations_0 => setAnnotations(annotations_0.filter(_temp));
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = value || "";
  let t13;
  if ($[13] !== disabled || $[14] !== onChange) {
    t13 = value_0 => !disabled && onChange(value_0);
    $[13] = disabled;
    $[14] = onChange;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== disabled || $[17] !== onBlur) {
    t14 = (event, editor) => !disabled && onBlur?.(editor?.getValue() || "");
    $[16] = disabled;
    $[17] = onBlur;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {};
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== annotations || $[21] !== disabled || $[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
    t16 = <AceEditor mode="html" width="100%" theme="textmate" fontSize={15} setOptions={t10} annotations={annotations} onValidate={t11} value={t12} highlightActiveLine={true} onChange={t13} onBlur={t14} name="code-editor" editorProps={t15} readOnly={disabled} />;
    $[20] = annotations;
    $[21] = disabled;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t16 || $[27] !== t8 || $[28] !== t9) {
    t17 = <div className={t8}>{t9}{t16}</div>;
    $[26] = t16;
    $[27] = t8;
    $[28] = t9;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== error) {
    t18 = <FieldErrorAndDescription error={error} />;
    $[30] = error;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== isValid || $[33] !== t) {
    t19 = !isValid && <FieldErrorAndDescription error={t("dashboard.code_editor.code_is_not_valid")} />;
    $[32] = isValid;
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t17 || $[36] !== t18 || $[37] !== t19 || $[38] !== t4) {
    t20 = <div className="flex w-full flex-col gap-1">{t4}{t17}{t18}{t19}</div>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t4;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
};
export default CodeEditor;
function _temp(annotation) {
  return !ignoredAnnotations.some(ignore => annotation.text.includes(ignore));
}